// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/tanstackstart-react/

import * as Sentry from "@sentry/tanstackstart-react";
import type { AnyRouter } from "@tanstack/react-router";

export function initializeClientSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [window.location.origin],
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
      }),
    ],

    enableLogs: true,
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function addClientSentryRouterTracing(router: AnyRouter) {
  Sentry.addIntegration(Sentry.tanstackRouterBrowserTracingIntegration(router));
}
